<div class="container">
  <div class="row card">
    <div class="card-body col-md-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openLg(transcript)">
        View video transcript
      </button>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - Write Your Story</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6" style="height: 35vh">
    <p>
      So finally here we are ready to start writing. I bet you never thought
      we'd get here! So, I have a little tip for you that will make your writing
      experience a little bit easier, and it's a very exciting word. It's one
      that I heard and from the first time I heard it, I never forgot it, and I
      hope you'll remember this as you're doing your writing. The word is
      verisimilitude, and what does that mean? That means, “The quality of your
      writing that makes it feel like it's real,” and these are the elements
      that I'm going to help you put into your story, so that your reader will
      feel like they were right there when that event happened. Something you
      may not realize is that writing can be messy. It doesn't always come out
      perfect right away. Let your first draft be your first draft. It's not
      like you're doing the brainstorming again, but you really are just
      bringing out all the details of what you remember about the topic you've
      chosen. We will be doing editing and rewriting and editing and rewriting.
      That's just the way the process goes, but it can be so much fun, so let's
      get started.
    </p>
    <p>
      One tip I want to give you about writing is focus on just the event you're
      writing about. It's easy to get carried away, because memory starts coming
      into play, but really all you want to do is focus on just exactly that
      photograph and that story and what makes it special.
    </p>
    <p>
      I remember once in a workshop, we were all writing our first story, truly
      the first time. Right where you are right now in this process. So, I
      walked around the room, and I see people have like a half a page to a full
      page written. I come upon this one student of mine, and she's got like one
      sentence, and I asked her what was wrong. “What stopping you?” and she
      says, “I can't remember how I spell wear. Is it W-E- A-R or W-A- R-E?” But
      let me just tell you that the point is don't let those things hang you up.
      Don’t worry about the grammar, the commas, the periods. Is it an
      exclamation point? Or whatever. Just right. Think of how well you did on
      the brainstorming session. This is like freewriting about the details of
      your story. Stay focused on your story, but don't get hung up on the
      details.
    </p>
    <p>
      Let's not get hung up on the details whenever you're writing your story.
      No one really wants to read two pages of what the chair looked like. What
      we want to hear is who was there and why were they there. Remember the
      five W's: who, what, why, when, and where? If you keep that in mind and
      focus on that, that will make your story much more readable.
    </p>
    <p>
      Don't get hung up on just giving a simple sentence like, “I was born in
      Boston, Massachusetts on such-and- such a date.” What the reader wants to
      know is what was special about that, besides the fact that you were born,
      but the fact that perhaps your father was almost late getting there, or
      maybe you find out that your mother was on the way and was riding her
      bicycle to the hospital while she was in labor, and your father was racing
      there in a car. Now that makes a good story.
    </p>
    <p>
      Once you're ready, click the pencil icon next to the story sentence idea.
      This will take you to a new page where you can write your story. There's
      no set story length, so just write as much as you need to tell the story
      and get your points across. So now you're ready to write. We've talked
      about so much, and it can be a little overwhelming, but don't go there.
      Don't let that happen. All I want you to do is just write. Tell your story
      and enjoy it and think about who you're writing for, and that will bring
      you such happiness. So, happy writing everyone!
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
